import React from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { setVh } from 'utils/utils';
import Routes from 'routes/index';
import history from 'utils/history';
import config from 'config';
import ErrorBoundary from 'components/common/ErrorBoundary';
import { GlobalStyle } from '@ebay-certilogo/design-system-web';
import { store, persistor } from './ducks';
import LanguageProvider from './containers/LanguageProvider';
import ThemeProvider from './ThemeProvider';

setVh();

const App = () => {
  return (
    <LanguageProvider>
      <ErrorBoundary>
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <ThemeProvider>
              <Router history={history} basename={config.basename}>
                <GlobalStyle />
                <Routes />
              </Router>
            </ThemeProvider>
          </PersistGate>
        </Provider>
      </ErrorBoundary>
    </LanguageProvider>
  );
};

export default App;
